import { useParams, useNavigate, Navigate } from "react-router-dom";
import Header from "../components/Header";
import "../assets/css/tag-status.css";
import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Modal,
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { service } from "../model";
import { useSelector } from "react-redux";
import BoxButton from "../components/BoxButton";
import ModalConferma from "../components/Generics/ModalConferma";
import ModalSuccess from "../components/Generics/ModalSuccess";
import ModalAmlForm from "../components/Generics/ModalAmlForm";
import { validationCreateAml } from "../utils/validation_create_aml";
import PopupError from "../components/Generics/PopupError";
import ModalNote from "../components/Generics/ModalNote";
import ModalRichiediConferma from "../components/Generics/ModalRichiediConferma";
import ModalArchivia from "../components/Generics/ModalArchivia";

const STATUS_LABEL_MAP = {
  sent: "Spedito",
  in_progress: "In compilazione",
  submitted: "Da verificare",
  rejected: "In correzione",
  pending_confirmation: "In ratifica",
  expired: "Scaduto",
  approved: "Valido",
  archived: "Archiviato",
};

const STATUS_CLASS_MAP = {
  Spedito: "tag-sent",
  "In compilazione": "tag-progress",
  "Da verificare": "tag-submitted",
  "In correzione": "tag-rejected",
  "In ratifica": "tag-ratifica",
  Scaduto: "tag-expired",
  Valido: "tag-approved",
  Archiviato: "tag-archived",
};

const Row = ({ label, value, highlight, onInfoClick }) => {
  if (!value) return null;
  return (
    <Grid container sx={{ py: 0.6 }} alignItems="flex-start">
      <Grid item xs={5} md={4}>
        <Typography
          style={{
            fontSize: "13px",
            color: "#888",
            fontWeight: 400,
            lineHeight: 1.6,
          }}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item xs={7} md={8} sx={{ display: "flex", alignItems: "center" }}>
        <Typography
          style={{
            fontSize: "13px",
            fontWeight: 600,
            color: "#1b2838",
            lineHeight: 1.6,
            display: "inline",
            backgroundColor: highlight ? "#fde8e8" : "transparent",
            borderRadius: "4px",
            padding: highlight ? "2px 6px" : 0,
            marginLeft: highlight ? "-6px" : 0,
          }}
        >
          {value}
        </Typography>
        {highlight && onInfoClick && (
          <div
            className="icon-modal-waning-small"
            style={{ marginLeft: "8px", cursor: "pointer", marginTop: "0px" }}
            onClick={onInfoClick}
          />
        )}
      </Grid>
    </Grid>
  );
};

const Section = ({ title, children, action }) => (
  <Box
    sx={{
      mb: 2,
      borderRadius: "12px",
      border: "1px solid #e8e8e8",
      overflow: "hidden",
      boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
    }}
  >
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        px: 3,
        py: 1.5,
        backgroundColor: "#f9f9f9",
        borderBottom: "1px solid #e8e8e8",
      }}
    >
      <Typography
        style={{
          fontWeight: 700,
          fontSize: "16px",
          letterSpacing: "0.06em",
          color: "#1b2838",
        }}
      >
        {title}
      </Typography>
      {action}
    </Box>
    <Box sx={{ px: 3, py: 2 }}>{children}</Box>
  </Box>
);

const DetailAml = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const reduxObject = useSelector((state) => state.user?.redux_object);
  const token = reduxObject.accessToken;
  const invalidId = !id || isNaN(Number(id));

  const [loadingAml, setLoadingAml] = useState(false);
  const [aml, setAml] = useState({});
  const [openDeleteAml, setOpenDeleteAml] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [editAml, setEditAml] = useState({});
  const [errorsEditAml, setErrorsEditAml] = useState([]);
  const [errorPopup, setErrorPopup] = useState(false);
  const [openSuccessEdit, setOpenSuccessEdit] = useState(false);
  const [openSuccessDelete, setOpenSuccessDelete] = useState(false);
  const [openRigetta, setOpenRigetta] = useState(false);
  const [openSuccessRigetta, setOpenSuccessRigetta] = useState(false);
  const [openErrorRigetta, setOpenErrorRigetta] = useState(false);
  const [openApprova, setOpenApprova] = useState(false);
  const [openSuccessApprova, setOpenSuccessApprova] = useState(false);
  const [openErrorApprova, setOpenErrorApprova] = useState(false);
  const [openInviaOtp, setOpenInviaOtp] = useState(false);
  const [openSuccessInviaOtp, setOpenSuccessInviaOtp] = useState(false);
  const [openErrorInviaOtp, setOpenErrorInviaOtp] = useState(false);
  const [openRigeneraLink, setOpenRigeneraLink] = useState(false);
  const [openInfoScadenza, setOpenInfoScadenza] = useState(false);
  const [openSuccessRigeneraLink, setOpenSuccessRigeneraLink] = useState(false);
  const [openErrorRigeneraLink, setOpenErrorRigeneraLink] = useState(false);
  const [openRiavvia, setOpenRiavvia] = useState(false);
  const [openSuccessRiavvia, setOpenSuccessRiavvia] = useState(false);
  const [openErrorRiavvia, setOpenErrorRiavvia] = useState(false);
  const [openErrorDownload, setOpenErrorDownload] = useState(false);
  const [openRichiediConferma, setOpenRichiediConferma] = useState(false);
  const [openSuccessRichiediConferma, setOpenSuccessRichiediConferma] = useState(false);
  const [openErrorRichiediConferma, setOpenErrorRichiediConferma] = useState(false);
  const [openArchivia, setOpenArchivia] = useState(false);
  const [openSuccessArchivia, setOpenSuccessArchivia] = useState(false);
  const [openErrorArchivia, setOpenErrorArchivia] = useState(false);
  const [openRegenerateLink, setOpenRegenerateLink] = useState(false);
  const [openSuccessRegenerateLink, setOpenSuccessRegenerateLink] = useState(false);
  const [openErrorRegenerateLink, setOpenErrorRegenerateLink] = useState(false);
  const [logsOpen, setLogsOpen] = useState(false);
  const isLinkExpired =
    aml?.link_expires_at &&
    new Date(aml.link_expires_at) < new Date() &&
    aml?.status !== "archived";

  const statusLabel = STATUS_LABEL_MAP[aml?.status] ?? aml?.status;
  const statusClass = STATUS_CLASS_MAP[statusLabel] ?? null;

  const openEdit = () => {
    setEditAml({ ...aml });
    setOpenEditModal(true);
  };
  const closeSuccessEdit = () => setOpenSuccessEdit(false);
  const closeSuccessDelete = () => {
    setOpenSuccessDelete(false);
    navigate(-1);
  };

  const loadAmlDetail = async () => {
    try {
      setLoadingAml(true);
      const amlObject = await service.getSingleAML(token, id);
      setAml(amlObject);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingAml(false);
    }
  };

  useEffect(() => {
    if (id) loadAmlDetail();
  }, [id]);

  const deleteAml = async () => {
    try {
      setLoadingAml(true);
      await service.deleteAml(token, id);
      setOpenDeleteAml(false);
      setOpenSuccessDelete(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleRigetta = async (note) => {
    try {
      setLoadingAml(true);
      await service.rejectAML(token, id, note);
      setOpenRigetta(false);
      setOpenSuccessRigetta(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenRigetta(false);
      setOpenErrorRigetta(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleApprova = async () => {
    try {
      setLoadingAml(true);
      await service.approveAML(token, id);
      setOpenApprova(false);
      setOpenSuccessApprova(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenApprova(false);
      setOpenErrorApprova(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleInviaOtp = async () => {
    try {
      setLoadingAml(true);
      await service.resendOTP(token, id);
      setOpenInviaOtp(false);
      setOpenSuccessInviaOtp(true);
    } catch (err) {
      console.error(err);
      setOpenInviaOtp(false);
      setOpenErrorInviaOtp(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleConfirmEditAml = async () => {
    const validationErrors = validationCreateAml(editAml);
    if (validationErrors.length > 0) {
      setErrorsEditAml(validationErrors);
      setErrorPopup(true);
      return;
    }
    try {
      setLoadingAml(true);
      await service.editAML(token, editAml, editAml.id);
      setErrorsEditAml([]);
      setOpenEditModal(false);
      await loadAmlDetail();
      setOpenSuccessEdit(true);
    } catch (error) {
      console.error(error);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleRigeneraLink = async () => {
    try {
      setLoadingAml(true);

      if (aml?.status === "rejected" || aml?.status === "expired") {
        await service.restartAML(token, id, {
          type: aml.type,
          name: aml.name,
          email: aml.email,
          language: aml.language,
          risk: aml.risk,
        });
      } else {
        await service.editAML(
          token,
          {
            type: aml.type,
            name: aml.name,
            email: aml.email,
            language: aml.language,
            risk: aml.risk,
          },
          id,
        );
      }

      setOpenRigeneraLink(false);
      setOpenSuccessRigeneraLink(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenRigeneraLink(false);
      setOpenErrorRigeneraLink(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleRiavvia = async () => {
    try {
      setLoadingAml(true);
      await service.restartAML(token, id, {
        type: aml.type,
        name: aml.name,
        email: aml.email,
        language: aml.language,
        risk: aml.risk,
      });
      setOpenRiavvia(false);
      setOpenSuccessRiavvia(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenRiavvia(false);
      setOpenErrorRiavvia(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const formatDocName = (name) => {
    if (!name) return name;
    return name.replace(/_([\d]+)_/g, (match, num) => `_${parseInt(num) + 1}_`);
  };

  const handleDownloadDocument = async (doc) => {
    try {
      const blob = await service.downloadDocument(token, doc.id);
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      a.download =
        doc.type === "client_aml_signed"
          ? "aml_firmato.pdf"
          : `${formatDocName(doc.assigned_name)}`;
      a.click();
      window.URL.revokeObjectURL(url);
    } catch (err) {
      console.error(err);
      setOpenErrorDownload(true);
    }
  };


  const handleRegenerateLink = async () => {
    try {
      setLoadingAml(true);
      await service.regenerateLink(token, id);
      setOpenRegenerateLink(false);
      setOpenSuccessRegenerateLink(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenRegenerateLink(false);
      setOpenErrorRegenerateLink(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleArchivia = async (archiveType, reason) => {
    try {
      setLoadingAml(true);
      await service.archiveAML(token, id, { archive_type: archiveType, reason: reason || "n/a" });
      if (archiveType === "not_confirmed") {
        await service.restartForUnconfirmed(token, id, {
          type: aml.type,
          name: aml.name,
          email: aml.email,
          language: aml.language,
          risk: aml.risk,
        });
      }
      setOpenArchivia(false);
      setOpenSuccessArchivia(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenArchivia(false);
      setOpenErrorArchivia(true);
    } finally {
      setLoadingAml(false);
    }
  };

  const handleRichiediConferma = async (assignmentTitle, assignmentReason) => {
    try {
      setLoadingAml(true);
      const body = { assignment_title: assignmentTitle };
      if (assignmentReason) body.assignment_reason = assignmentReason;
      await service.confirmationRequest(token, id, body);
      setOpenRichiediConferma(false);
      setOpenSuccessRichiediConferma(true);
      await loadAmlDetail();
    } catch (err) {
      console.error(err);
      setOpenRichiediConferma(false);
      setOpenErrorRichiediConferma(true);
    } finally {
      setLoadingAml(false);
    }
  };

  console.log(aml)

  const btnSx = {
    height: "34px",
    minWidth: "160px !important",
    width: "160px !important",
    borderRadius: "10px !important",
    border: "1px solid #1b2838 !important",
    display: "flex",
    justifyContent: "center",
    gap: "8px",
  };

  const btnTextSx = {
    fontSize: "14px",
    fontWeight: 600,
    textTransform: "initial",
    color: "#1b2838",
    mt: "3px",
  };

  if (invalidId) return <Navigate to="/aml/moduli-in-raccolta" replace />;

  return (
    <>
      {loadingAml && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,0.5)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 2000,
          }}
        >
          <CircularProgress sx={{ color: "#1b2838" }} />
        </div>
      )}

      <div
        style={{ display: "flex", flexDirection: "column", height: "100vh" }}
      >
        <div style={{ position: "fixed", top: 0, width: "100%", zIndex: 1000 }}>
          <Header />
        </div>

        <Grid
          container
          justifyContent="center"
          sx={{ mt: "140px", px: 2, pb: "80px" }}
        >
          <Grid item xs={12} md={10}>
            {/* ── TITOLO ── */}
            <Box
              sx={{
                display: "flex",
                alignItems: { xs: "flex-start", sm: "center" },
                justifyContent: "space-between",
                mb: 3,
                flexWrap: "wrap",
                gap: 2,
                flexDirection: { xs: "column", sm: "row" },
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                <Typography
                  className="color-blue-dark"
                  sx={{ fontSize: { xs: "20px", md: "24px" }, fontWeight: 700 }}
                >
                  Modello AML #{aml?.id}
                </Typography>
                {statusLabel && (
                  <Typography
                    component="span"
                    className={statusClass}
                    sx={{
                      fontWeight: 500,
                      px: 2,
                      py: "6px",
                      display: "inline-flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "14px",
                      textTransform: "uppercase",
                      borderRadius: "10px",
                      minWidth: "100px",
                      color: "#1b2838",
                    }}
                  >
                    {statusLabel}
                  </Typography>
                )}
              </Box>

              <Box sx={{
                display: "flex",
                flexDirection: { xs: "column", sm: "row" },
                gap: 1.5,
                width: { xs: "100%", sm: "auto" },
                alignItems: { xs: "flex-start", sm: "center" },
              }}>
                {aml?.status === "approved" && (
                  <Button
                    variant="outlined"
                    className="button-bg-empty"
                    onClick={() => setOpenRichiediConferma(true)}
                    sx={btnSx}
                  >
                    <Box className="icon-generate-otp-button" />
                    <Typography sx={btnTextSx}>Richiedi conferma</Typography>
                  </Button>
                )}

                {aml?.status !== "archived" && (
                  <Button
                    variant="outlined"
                    className="button-bg-empty"
                    onClick={() => setOpenArchivia(true)}
                    sx={btnSx}
                  >
                    <Box className="icon-modal-archived" />
                    <Typography sx={btnTextSx}>Archivia</Typography>
                  </Button>
                )}

                <Button
                  variant="outlined"
                  className="button-bg-empty"
                  onClick={() => setOpenDeleteAml(true)}
                  sx={btnSx}
                >
                  <Box className="icon-delete-aml-button" />
                  <Typography sx={btnTextSx}>Elimina</Typography>
                </Button>

                {aml?.status !== "archived" && aml?.status !== "approved" && (
                  <Button
                    variant="outlined"
                    className="button-bg-empty"
                    onClick={() => setOpenRegenerateLink(true)}
                    sx={btnSx}
                  >
                    <Box className="icon-generate-otp-button" />
                    <Typography sx={btnTextSx}>Rigenera Link</Typography>
                  </Button>
                )}

                {aml?.status !== "archived" && aml?.status !== "approved" && (
                  <Button
                    variant="outlined"
                    className="button-bg-empty"
                    onClick={() => setOpenInviaOtp(true)}
                    sx={btnSx}
                  >
                    <Box className="icon-generate-otp-button" />
                    <Typography sx={btnTextSx}>Rigenera OTP</Typography>
                  </Button>
                )}

              </Box>
            </Box>

            {/* ── DATI GENERALI ── */}
            <Section title="Dati generali">
              <Row label="Cliente" value={aml?.name} />
              <Row label="Email" value={aml?.email} />
              <Row
                label="Tipologia"
                value={
                  aml?.type === "PF"
                    ? "Persona fisica"
                    : aml?.type === "PG"
                      ? "Persona giuridica"
                      : "-"
                }
              />
              <Row
                label="Lingua"
                value={
                  aml?.language === "it"
                    ? "Italiano"
                    : aml?.language === "en"
                      ? "Inglese"
                      : "-"
                }
              />

              <Row
                label="Rischio"
                value={
                  aml?.risk === "medium"
                    ? "Medio"
                    : aml?.risk === "high"
                      ? "Alto"
                      : "-"
                }
              />
              <Row
                label="Data creazione"
                value={
                  aml?.created_at
                    ? new Date(aml.created_at).toLocaleDateString("it-IT")
                    : "-"
                }
              />
              {["sent", "in_progress", "submitted", "rejected"].includes(
                aml?.status,
              ) && (
                <Row
                  label="Scadenza link"
                  highlight={isLinkExpired}
                  onInfoClick={() => setOpenInfoScadenza(true)}
                  value={
                    aml?.link_expires_at
                      ? new Date(aml.link_expires_at).toLocaleDateString(
                          "it-IT",
                        )
                      : "-"
                  }
                />
              )}
              {aml?.status === "rejected" && (
                <Row label="Motivo rigetto" value={aml?.reject_reason} />
              )}

              {["archived", "expired", "in_progress"].includes(aml?.status) &&
                aml?.reason_expiration && (
                  <Row label="Motivo scadenza" value={aml?.reason_expiration} />
                )}
            </Section>

            {/* ── DOCUMENTI ── */}
            {[
              "submitted",
              "rejected",
              "expired",
              "approved",
              "archived",
            ].includes(aml?.status) &&
              (aml?.documents || []).length > 0 && (
                <Section title="Documenti">
                  <Box
                    sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}
                  >
                    {(aml?.documents || [])
                      .filter((doc) => doc.type !== "generated_pdf")
                      .map((doc) => (
                        <Box
                          key={doc.id}
                          sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                            px: 3,
                            py: 2,
                            borderRadius: "10px",
                            border: "1px solid #e8e8e8",
                            backgroundColor: "#fafafa",
                          }}
                        >
                          <Box>
                            <Typography
                              style={{
                                fontSize: "14px",
                                fontWeight: 600,
                                color: "#1b2838",
                              }}
                            >
                              {doc.type === "client_aml_signed"
                                ? "aml_firmato"
                                : formatDocName(doc.assigned_name)}
                            </Typography>
                          </Box>
                          <Box
                            className="icon-download-document-aml"
                            sx={{ cursor: "pointer" }}
                            onClick={() => handleDownloadDocument(doc)}
                          />
                        </Box>
                      ))}
                  </Box>
                </Section>
              )}
            {/* ── LOG ── */}
            {(aml?.logs || []).length > 0 && (
              <Box
                sx={{
                  mb: 2,
                  borderRadius: "12px",
                  border: "1px solid #e8e8e8",
                  overflow: "hidden",
                  boxShadow: "0 1px 4px rgba(0,0,0,0.04)",
                }}
              >
                <Box
                  onClick={() => setLogsOpen((prev) => !prev)}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    px: 3,
                    py: 1.5,
                    backgroundColor: "#f9f9f9",
                    borderBottom: logsOpen ? "1px solid #e8e8e8" : "none",
                    cursor: "pointer",
                    userSelect: "none",
                  }}
                >
                  <Typography
                    style={{
                      fontWeight: 700,
                      fontSize: "16px",
                      letterSpacing: "0.06em",
                      color: "#1b2838",
                    }}
                  >
                    Log
                  </Typography>
                  <Box
                    sx={{
                      width: 20,
                      height: 20,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "transform 0.2s",
                      transform: logsOpen ? "rotate(180deg)" : "rotate(0deg)",
                    }}
                  >
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
                      <path
                        d="M2 4l4 4 4-4"
                        stroke="#888"
                        strokeWidth="1.5"
                        strokeLinecap="round"
                        strokeLinejoin="round"
                      />
                    </svg>
                  </Box>
                </Box>
                {logsOpen && (
                  <Box sx={{ px: 3, py: 2, display: "flex", flexDirection: "column", gap: 1.5 }}>
                    {(aml?.logs || []).map((log) => (
                      <Box
                        key={log.id}
                        sx={{
                          px: 3,
                          py: 2,
                          borderRadius: "10px",
                          border: "1px solid #e8e8e8",
                          backgroundColor: "#fafafa",
                        }}
                      >
                        <Box sx={{ display: "flex", justifyContent: "space-between", mb: 0 }}>
                          <Typography style={{ fontSize: "13px", fontWeight: 600, color: "#1b2838" }}>
                            {log.message}
                          </Typography>
                          <Typography style={{ fontSize: "12px", color: "#888" }}>
                            {new Date(log.created_at).toLocaleString("it-IT")}
                          </Typography>
                        </Box>
                        {/* <Box sx={{ display: "flex", gap: 1 }}>
                          <Typography style={{ fontSize: "12px", color: "#888" }}>
                            {log.actor_type}
                          </Typography>
                          {log.event && (
                            <Typography style={{ fontSize: "12px", color: "#888" }}>
                              · {log.event}
                            </Typography>
                          )}
                        </Box> */}
                        {log.metadata?.old_aml_id && (
                          <Box
                            onClick={() => navigate(`/aml/${log.metadata.old_aml_id}`)}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.5,
                              mt: 1,
                              px: 1.5,
                              py: 0.5,
                              borderRadius: "6px",
                              border: "1px solid #c6c6c6",
                              backgroundColor: "#f0f0f0",
                              cursor: "pointer",
                              width: "fit-content",
                              "&:hover": { backgroundColor: "#e0e0e0" },
                            }}
                          >
                            <Typography style={{ fontSize: "12px", color: "#1b2838", fontWeight: 600 }}>
                              AML #{log.metadata.old_aml_id}
                            </Typography>
                            {log.metadata.old_aml_status && (
                              <Typography style={{ fontSize: "12px", color: "#888" }}>
                                · {STATUS_LABEL_MAP[log.metadata.old_aml_status] ?? log.metadata.old_aml_status}
                              </Typography>
                            )}
                          </Box>
                        )}
                        {log.event === "aml_archived_not_confirmed" && log.metadata?.new_aml_id && (
                          <Box
                            onClick={() => navigate(`/aml/${log.metadata.new_aml_id}`)}
                            sx={{
                              display: "inline-flex",
                              alignItems: "center",
                              gap: 0.5,
                              mt: 1,
                              px: 1.5,
                              py: 0.5,
                              borderRadius: "6px",
                              border: "1px solid #c6c6c6",
                              backgroundColor: "#f0f0f0",
                              cursor: "pointer",
                              width: "fit-content",
                              "&:hover": { backgroundColor: "#e0e0e0" },
                            }}
                          >
                            <Typography style={{ fontSize: "12px", color: "#1b2838", fontWeight: 600 }}>
                              AML #{log.metadata.new_aml_id}
                            </Typography>
                            {log.metadata.new_aml_status && (
                              <Typography style={{ fontSize: "12px", color: "#888" }}>
                                · {STATUS_LABEL_MAP[log.metadata.new_aml_status] ?? log.metadata.new_aml_status}
                              </Typography>
                            )}
                          </Box>
                        )}
                      </Box>
                    ))}
                  </Box>
                )}
              </Box>
            )}
          </Grid>
        </Grid>

        <BoxButton
          onRigenera={() => setOpenRigetta(true)}
          onApprova={() => setOpenApprova(true)}
          onRiavvia={() => setOpenRiavvia(true)}
          amlStatus={aml?.status}
        />
      </div>

      {/* ── DELETE CONFIRM ── */}
      <Modal open={openDeleteAml} onClose={() => setOpenDeleteAml(false)}>
        <div>
          <ModalConferma
            tag="delete"
            title="Elimina modulo AML"
            descriptionOne="L'eliminazione del modulo è un'azione irreversibile che cancella definitivamente la procedura e blocca il link per la compilazione del cliente. Sei sicuro di voler procedere?"
            copyButton="Sì, elimina"
            confirm={deleteAml}
            onClose={() => setOpenDeleteAml(false)}
          />
        </div>
      </Modal>

      {/* ── RIGETTA MODAL ── */}
      <Modal open={openRigetta} onClose={() => setOpenRigetta(false)}>
        <ModalNote
          title="Rigetta modulo AML"
          descriptionOne="Inserisci la nota che verrà inviata al cliente con le istruzioni precise per la correzione. In basso puoi visualizzare l'anteprima completa dell'email che riceverà il cliente."
          copyButton="Rigetta"
          copyButtonClose="Chiudi"
          onClose={() => setOpenRigetta(false)}
          confirm={handleRigetta}
        />
      </Modal>

      {/* ── SUCCESS RIGETTA ── */}
      <Modal
        open={openSuccessRigetta}
        onClose={() => setOpenSuccessRigetta(false)}
      >
        <div>
          <ModalSuccess
            title="Modulo AML rigettato con successo"
            descriptionOne="Il cliente è stato invitato via email ad apportare le dovute correzioni/integrazioni."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessRigetta(false)}
            onClose={() => setOpenSuccessRigetta(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR RIGETTA ── */}
      <Modal open={openErrorRigetta} onClose={() => setOpenErrorRigetta(false)}>
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante il rigetto del modulo. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorRigetta(false)}
            onClose={() => setOpenErrorRigetta(false)}
          />
        </div>
      </Modal>

      {/* ── APPROVA MODAL ── */}
      <Modal open={openApprova} onClose={() => setOpenApprova(false)}>
        <div>
          <ModalConferma
            tag="approved"
            title="Approva modulo AML"
            descriptionOne="L'approvazione del modulo è un'azione irreversibile che cristallizza il modulo e libera il cliente da ulteriori azioni. Sei sicuro di voler procedere?"
            descriptionTwo=""
            copyButton="Approva"
            confirm={handleApprova}
            onClose={() => setOpenApprova(false)}
          />
        </div>
      </Modal>

      {/* ── SUCCESS APPROVA ── */}
      <Modal
        open={openSuccessApprova}
        onClose={() => setOpenSuccessApprova(false)}
      >
        <div>
          <ModalSuccess
            title="Modulo AML approvato con successo"
            descriptionOne={`Il modulo AML è stato approvato ed è presente nella sezione "Moduli validi" del Centro AML. Il link di compilazione del cliente è stato disattivato.`}
            copyButton="Chiudi"
            confirm={() => setOpenSuccessApprova(false)}
            onClose={() => setOpenSuccessApprova(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR APPROVA ── */}
      <Modal open={openErrorApprova} onClose={() => setOpenErrorApprova(false)}>
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante l'approvazione del modulo. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorApprova(false)}
            onClose={() => setOpenErrorApprova(false)}
          />
        </div>
      </Modal>

      {/* ── INVIA OTP ── */}
      <Modal open={openInviaOtp} onClose={() => setOpenInviaOtp(false)}>
        <div>
          <ModalConferma
            tag="otp"
            title="Rigenera OTP"
            descriptionOne="Confermi di voler inviare al cliente un nuovo codice OPT per accedere alla compilazione del modulo AML?"
            descriptionTwo=""
            copyButton="Invia"
            confirm={handleInviaOtp}
            onClose={() => setOpenInviaOtp(false)}
          />
        </div>
      </Modal>

      {/* ── SUCCESS INVIA OTP ── */}
      <Modal
        open={openSuccessInviaOtp}
        onClose={() => setOpenSuccessInviaOtp(false)}
      >
        <div>
          <ModalSuccess
            title="OTP rigenerato con successo"
            descriptionOne="Il cliente riceverà alla sua mail il nuovo codice per proseguire con la compilazione del modulo AML."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessInviaOtp(false)}
            onClose={() => setOpenSuccessInviaOtp(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR INVIA OTP ── */}
      <Modal
        open={openErrorInviaOtp}
        onClose={() => setOpenErrorInviaOtp(false)}
      >
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante l'invio dell'OTP. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorInviaOtp(false)}
            onClose={() => setOpenErrorInviaOtp(false)}
          />
        </div>
      </Modal>

      {/* ── RIGENERA LINK ── */}
      <Modal open={openRigeneraLink} onClose={() => setOpenRigeneraLink(false)}>
        <div>
          <ModalConferma
            tag="expired"
            title="Rigenera link"
            descriptionOne="Confermi di voler rigenerare il link per la compilazione del modulo AML? "
            descriptionTwo="Il cliente riceverà un nuovo link via email."
            copyButton="Sì, rigenera"
            confirm={handleRigeneraLink}
            onClose={() => setOpenRigeneraLink(false)}
          />
        </div>
      </Modal>

      {/* ── SUCCESS RIGENERA LINK ── */}
      <Modal
        open={openSuccessRigeneraLink}
        onClose={() => setOpenSuccessRigeneraLink(false)}
      >
        <div>
          <ModalSuccess
            title="Link rigenerato con successo"
            descriptionOne="Il cliente riceverà via email il nuovo link per accedere alla compilazione del modulo AML."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessRigeneraLink(false)}
            onClose={() => setOpenSuccessRigeneraLink(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR RIGENERA LINK ── */}
      <Modal
        open={openErrorRigeneraLink}
        onClose={() => setOpenErrorRigeneraLink(false)}
      >
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante la rigenerazione del link. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorRigeneraLink(false)}
            onClose={() => setOpenErrorRigeneraLink(false)}
          />
        </div>
      </Modal>

      <Modal open={openInfoScadenza} onClose={() => setOpenInfoScadenza(false)}>
        <div>
          <ModalConferma
            title="Link scaduto"
            descriptionOne="Il cliente è stato inerte e il link è stato disattivato per motivi di sicurezza. Puoi comunque rigenerarlo all'occorrenza."
            copyButton="Chiudi"
            confirm={() => setOpenInfoScadenza(false)}
            onClose={() => setOpenInfoScadenza(false)}
          />
        </div>
      </Modal>

      {/* ── RINNOVA MODAL ── */}
      <Modal open={openRiavvia} onClose={() => setOpenRiavvia(false)}>
        <div>
          <ModalConferma
            tag="expired"
            title="Rinnova modulo AML"
            descriptionOne={`Se confermi il rinnovo, il cliente riceverà un link per la raccolta dati di un nuovo modulo AML. Il modulo scaduto invece passerà in stato "Archiviato" e sarà sempre consultabile.`}
            descriptionTwo="Confermi di voler procedere?"
            copyButton="Sì, rinnova"
            confirm={handleRiavvia}
            onClose={() => setOpenRiavvia(false)}
          />
        </div>
      </Modal>

      {/* ── SUCCESS RINNOVA ── */}
      <Modal
        open={openSuccessRiavvia}
        onClose={() => setOpenSuccessRiavvia(false)}
      >
        <div>
          <ModalSuccess
            title="Modulo AML rinnovato con successo"
            descriptionOne="Il cliente riceverà via email il nuovo link per accedere alla compilazione del nuovo modulo AML."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessRiavvia(false)}
            onClose={() => setOpenSuccessRiavvia(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR RINNOVA ── */}
      <Modal open={openErrorRiavvia} onClose={() => setOpenErrorRiavvia(false)}>
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante il rinnovo del modulo. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorRiavvia(false)}
            onClose={() => setOpenErrorRiavvia(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR DOWNLOAD ── */}
      <Modal
        open={openErrorDownload}
        onClose={() => setOpenErrorDownload(false)}
      >
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante il download del documento. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorDownload(false)}
            onClose={() => setOpenErrorDownload(false)}
          />
        </div>
      </Modal>

      {/* ── RICHIEDI CONFERMA MODAL ── */}
      <Modal
        open={openRichiediConferma}
        onClose={() => setOpenRichiediConferma(false)}
      >
        <ModalRichiediConferma
          title="Richiedi conferma"
          descriptionOne="Stai richiedendo la conferma dei dati di un modulo AML già valido. La conferma è necessaria in quanto LEXIA sta assumendo un nuovo incarico con questo cliente. Per proseguire, seleziona la tipologia di nuovo incarico."
          copyButton="Invia"
          amlId={id}
          onClose={() => setOpenRichiediConferma(false)}
          confirm={handleRichiediConferma}
        />
      </Modal>

      {/* ── SUCCESS RICHIEDI CONFERMA ── */}
      <Modal
        open={openSuccessRichiediConferma}
        onClose={() => setOpenSuccessRichiediConferma(false)}
      >
        <div>
          <ModalSuccess
            title="Richiesta di conferma inviata correttamente"
            descriptionOne="Richiesta di conferma inviata correttamente. Il cliente ha ricevuto un'email con cui potrà confermare i dati. Qualora non volesse confermarli, il cliente è stato invitato a contattare l'amministrazione LEXIA. Potrai quindi gestire l'eventuale modifica dei dati in seguito."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessRichiediConferma(false)}
            onClose={() => setOpenSuccessRichiediConferma(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR RICHIEDI CONFERMA ── */}
      <Modal
        open={openErrorRichiediConferma}
        onClose={() => setOpenErrorRichiediConferma(false)}
      >
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante l'invio della richiesta di conferma. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorRichiediConferma(false)}
            onClose={() => setOpenErrorRichiediConferma(false)}
          />
        </div>
      </Modal>

      {/* ── ARCHIVIA MODAL ── */}
      <Modal open={openArchivia} onClose={() => setOpenArchivia(false)}>
        <ModalArchivia
          onClose={() => setOpenArchivia(false)}
          confirm={handleArchivia}
          amlStatus={aml?.status}
        />
      </Modal>

      {/* ── SUCCESS ARCHIVIA ── */}
      <Modal open={openSuccessArchivia} onClose={() => setOpenSuccessArchivia(false)}>
        <div>
          <ModalSuccess
            title="Modulo AML archiviato con successo"
            descriptionOne="Il modulo AML è stato archiviato ed è consultabile nella sezione Ricerca moduli."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessArchivia(false)}
            onClose={() => setOpenSuccessArchivia(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR ARCHIVIA ── */}
      <Modal open={openErrorArchivia} onClose={() => setOpenErrorArchivia(false)}>
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante l'archiviazione del modulo. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorArchivia(false)}
            onClose={() => setOpenErrorArchivia(false)}
          />
        </div>
      </Modal>

      {/* ── RIGENERA LINK ── */}
      <Modal open={openRegenerateLink} onClose={() => setOpenRegenerateLink(false)}>
        <div>
          <ModalConferma
            tag="expired"
            title="Rigenera Link"
            descriptionOne="Confermi di voler rigenerare il link per la compilazione del modulo AML?"
            descriptionTwo="Il cliente riceverà un nuovo link via email."
            copyButton="Sì, rigenera"
            confirm={handleRegenerateLink}
            onClose={() => setOpenRegenerateLink(false)}
          />
        </div>
      </Modal>

      {/* ── SUCCESS RIGENERA LINK ── */}
      <Modal open={openSuccessRegenerateLink} onClose={() => setOpenSuccessRegenerateLink(false)}>
        <div>
          <ModalSuccess
            title="Link rigenerato con successo"
            descriptionOne="Il cliente riceverà via email il nuovo link per accedere alla compilazione del modulo AML."
            copyButton="Chiudi"
            confirm={() => setOpenSuccessRegenerateLink(false)}
            onClose={() => setOpenSuccessRegenerateLink(false)}
          />
        </div>
      </Modal>

      {/* ── ERROR RIGENERA LINK ── */}
      <Modal open={openErrorRegenerateLink} onClose={() => setOpenErrorRegenerateLink(false)}>
        <div>
          <ModalConferma
            title="Errore"
            descriptionOne="Si è verificato un errore durante la rigenerazione del link. Riprova."
            copyButton="Chiudi"
            confirm={() => setOpenErrorRegenerateLink(false)}
            onClose={() => setOpenErrorRegenerateLink(false)}
          />
        </div>
      </Modal>

      {errorPopup && (
        <div
          style={{
            width: "350px",
            position: "fixed",
            bottom: "-15px",
            left: "50%",
            backgroundColor: "#fff",
            transform: "translate(-50%, -50%)",
            zIndex: 2000,
            padding: "12px 10px",
            boxShadow: "0px 4px 6px rgba(0,0,0,0.2)",
            fontSize: "14px",
          }}
        >
          <PopupError
            copyError="Uno o più campi obbligatori sono mancanti"
            closePopupError={() => setErrorPopup(false)}
          />
        </div>
      )}

      <Modal open={openSuccessEdit} onClose={closeSuccessEdit}>
        <div>
          <ModalSuccess
            title="Modifiche salvate"
            copyButton="Chiudi"
            confirm={closeSuccessEdit}
            onClose={closeSuccessEdit}
          />
        </div>
      </Modal>

      <Modal open={openSuccessDelete} onClose={closeSuccessDelete}>
        <div>
          <ModalSuccess
            title="Modulo AML eliminato"
            descriptionOne="Il modulo AML è stato eliminato definitivamente dal Centro AML e il link di compilazione del cliente è stato disattivato."
            copyButton="Chiudi"
            confirm={closeSuccessDelete}
            onClose={closeSuccessDelete}
          />
        </div>
      </Modal>
    </>
  );
};

export default DetailAml;
